import { COLORS } from "@tecumseh/theme/design";

export default {
    primary: {
        main: COLORS.primary.base,
        contrast: COLORS.primary.contrast,
        // Custom
        light: COLORS.primary.light, // #343232
        dark: COLORS.primary.dark, // #ffbd0c
    },
    secondary: {
        main: COLORS.secondary.base,
        contrast: COLORS.white, // #ffffff
        // Custom
        light: COLORS.secondary.light, // #343232
        dark: COLORS.secondary.dark, // #343232
    },
    common: {
        background: COLORS.white, // #ffffff
        backgroundContrast: COLORS.text.base, // #212121
        accent: COLORS.background.alt, // #F6F6F6
        accentContrast: COLORS.text.base, // #212121
        border: COLORS.border.base, // #e2e3e6
        disabled: COLORS.disabled.base, // #e2e3e6
        // Custom
        disabledLighter: COLORS.disabled.lighter, // #F6F6F6
        disabledLight: COLORS.disabled.light, // #F3F5F7
        borderLight: COLORS.border.light, // ##BDBBBD
        borderDark: COLORS.border.dark, // #5d5f62
        borderDarker: COLORS.border.darker, // #00000
        backgroundHover: COLORS.background.hover, // #F3F5F7
        grayBackground: COLORS.background.grayShade,
    },
    text: {
        main: COLORS.text.lighter, // #636161
        disabled: COLORS.text.lighter, // #A7ABB0
        accent: COLORS.text.light, // #55595D
        link: COLORS.link.base,
        // Custom
        linkHover: COLORS.link.hover, // #55595D
    },
    success: {
        main: COLORS.success, // #028526
        contrast: COLORS.white, // #ffffff
    },
    danger: {
        main: COLORS.error, // #df1642
        contrast: COLORS.white, // #ffffff
    },
    warning: {
        main: COLORS.warning, // #E37217
        contrast: COLORS.white, // #ffffff
    },
    info: {
        main: COLORS.info.base, // #1d8ed5
        contrast: COLORS.white,
    },
    // Custom
    pagination: {
        main: COLORS.pagination.base, // #F3F5F7
        hover: COLORS.pagination.hover, // #CDCFD1
    },
    link: {
        main: COLORS.link.base,
    }
};
